<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="title">The Organ Grinder’s Monkey</p>
<p class="title_1">Richard Fliegel</p>
<p class="title1"><img alt="" class="figure" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0df0a410